import React, { useEffect, useState } from "react";






import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, } from "@mui/material";
import { Form, Input, message, Select, Button, Dropdown, Menu } from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { MoreOutlined } from '@ant-design/icons';


import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { VEH_AGREEMENT_URL, VEH_IMAGE_URL } from "../../Api/constants";

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
} from '@mui/material';
import AgreementDataTable from "../../Components/AgreementsDataTable";
import DataTable from "../../Components/DataTable";
import { capitalizeFirstLetter, getDateString } from "../../config/functions";
import InvoicesDataTable from "../../Components/InvoicesDataTable";


const { Option } = Select;




const CustomerInvoices = () => {


    const navigate = useNavigate();
    const { id } = useParams();

    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const user = useSelector((state) => state.authReducer.user);
    const [invoices, setInvoices] = useState([]);
    const [invoicesTemp, setInvoicesTemp] = useState([]);
    const [activeTab, setActiveTab] = useState('all');





    const getCustInvoices = async () => {
        const onSuccess = (res) => {
            dispatch(setLoader(false));
            console.log('res___', res.data);
            setInvoices(res.data?.reverse());
            setInvoicesTemp(res.data?.reverse());
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            console.log('err', err)
            message(err?.data?.error)
        }

        const body = {
            token: user?.token,
            cust_id: id
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getCustInvoices, onSuccess, onError);

    }

    const handleActionClick = (record) => {
        // console.log('action', action);
        const onSuccess = (res) => {
            dispatch(setLoader(false));
            console.log('res___', res.data);
            message.success(res?.data?.message)
            getCustInvoices();
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            console.log('err', err)
            message.error(err?.data?.error)
        }
        const body = {
            token: user?.token,
            inv_id: record.inv_id,
        }
        dispatch(setLoader(true));
        postRequest(body, apiRoutes.cancelInvoice, onSuccess, onError);

    }

    const changeTab = (tab) => {
        setActiveTab(tab);
        if (tab == 'all') {
            setInvoices(invoicesTemp);
        }
        else {
            const temp = invoicesTemp.filter((invoice) => invoice.status == tab);
            setInvoices(temp);
        }
    }



    const columns = [
        {
            title: 'Invoice id',
            dataIndex: 'inv_id',
            key: 'Invoice id',
            render: (text, record) => <Link
                to={{
                    pathname: `/transaction-details/${record?.inv_id}`,
                    state: record,
                }}
            >
                {text}
            </Link>,
        },
        {
            title: 'Reg no.',
            dataIndex: 'reg_no',
            key: 'reg_no',
        },
        {
            title: 'Customer',
            dataIndex: 'cust_name',
            key: 'name'

        },
        {
            title: 'Inv amount',
            dataIndex: 'inv_amount',
            key: 'inv_amount',
        },
        {
            title: 'Paid amount',
            dataIndex: 'paid_amount',
            key: 'paid_amount',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_id, record) => (
                <div>{capitalizeFirstLetter(record.status)}</div>
            )
        },

        // {
        //     title: 'Remarks',
        //     dataIndex: 'remarks',
        //     key: 'remarks',
        // },

        {
            title: 'Due date',
            dataIndex: 'due_date',
            key: 'due_date',
        },


        {
            title: 'Generated at',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (_id, record) => (
                <div>{getDateString(record.created_at)}</div>
            )
        },
        {
            title: 'Under-review transactions',
            dataIndex: 'pending_transactionsa',
            key: 'pending_transactionsa',
            render: (text, record) => record?.pending_transactionsa > 0 ? <Link
                style={{ color: 'red', textAlign: 'center' }}
                to={{
                    pathname: `/transaction-details/${record?.inv_id}`,
                    state: record,
                }}
            >
                {text}
            </Link > : <div>{record?.pending_transactionsa}</div>
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Dropdown
                    overlay={
                        <Menu onClick={({ key }) => { handleActionClick(record) }}>
                            {
                                record.status == 'pending' ? <Menu.Item key="cancel">Cancel Invoice</Menu.Item> : null
                            }
                        </Menu>
                    }
                    trigger={['click']}
                >
                    <Button>
                        <MoreOutlined style={{ fontWeight: 'bolder' }} />
                    </Button>
                </Dropdown>
            ),

        },
    ];



    useEffect(() => {
        // dispatch(setLoader(true));
        getCustInvoices();
    }, [])


    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', }}>
                    <Sidebars />
                    <div style={{ marginLeft: 10, }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                                Customer Invoices
                            </span>
                            <Button
                                onClick={() => navigate('/new-invoices')}
                                style={{ backgroundColor: appColors.primary, color: 'white', fontFamily: 'Poppins', fontSize: 12, textTransform: 'none', top: 95, position: 'absolute', right: 50 }}
                                variant="contained"
                            >Add new invoice</Button>
                        </div>

                        <div style={tabContainer} >
                            <div
                                onClick={() => changeTab('all')}
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}>
                                <Typography sx={tabText} >
                                    All
                                </Typography>
                                {activeTab == 'all' && <div style={focusedTabLine} />}
                            </div>
                            <div
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                                onClick={() => changeTab('paid')}
                            >
                                <Typography sx={tabText} >
                                    Paid
                                </Typography>
                                {activeTab == 'paid' && <div style={focusedTabLine} />}
                            </div>
                            <div
                                style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                                onClick={() => changeTab('pending')}
                            >
                                <Typography sx={tabText} >
                                    Pending
                                </Typography>
                                {activeTab == 'pending' && <div style={focusedTabLine} />}
                            </div>


                        </div>

                        <div>
                            <InvoicesDataTable
                                search={false}
                                data={invoices} columns={columns} />
                        </div>
                    </div>
                </div>



            </ThemeProvider>
        </>
    )

}

const tabContainer = {
    display: 'flex',
    marginTop:20,
    flexDirection: 'row',
    backgroundColor: 'white',
    width: 180,
    borderRadius: 15,
    paddingTop: 10, paddingRight: 20, paddingLeft: 20,
    justifyContent: 'space-between',
    boxShadow: '0px 4px 4px rgba(31, 31, 31, 0.1)',


}
const tabText = {
    fontSize: 14,
    color: '#000000',
    fontFamily: 'Poppins',


}

const focusedTabLine = {
    backgroundColor: appColors.primary,
    width: 25,
    height: 2,
    marginTop: 5

}

export default CustomerInvoices
